import { ChequePrintTemplate } from "../types";

import { Row } from "components/Row/Row";
import { Paragraph } from "components/Paragraph/Paragraph";

import styles from "../styles.module.scss";

type Selection = number | "new" | null;

type Props = {
  templates: ChequePrintTemplate[];
  selected: Selection;
  onSelect: (id: Selection) => void;
};

export function ChequePrintTemplatesList({
  templates,
  selected,
  onSelect,
}: Props): JSX.Element {
  return (
    <div className={styles.list}>
      {templates.map((t) => (
        <Row
          key={t.printtemplateid}
          isActive={
            typeof selected === "number" &&
            selected === t.printtemplateid
          }
          onClick={() => onSelect(t.printtemplateid)}
        >
          <Paragraph className={styles.listItemText}>{t.name}</Paragraph>
        </Row>
      ))}
    </div>
  );
}
